// @flow

import React, {Component} from 'react'
import {connect} from 'react-redux'
import {appActions, appSelectors, formActions} from '@/store'
import type {Language, CustomerUser} from '@/types'
import Users from './users'
import {mergeAll} from 'ramda'

type Props = {
  l: Language,
  users: Array<CustomerUser>,
  getCustomerUsers: () => void,
  fetchLoader: boolean,
  updateLoader: boolean,
  storeFormField: (any) => void,
  setFormData: (any) => void,
}

type State = {
  users: Array<CustomerUser>,
  revokeAll: boolean,
  showRevokeAll: boolean,
}

export class RawSharePortfolioForm extends Component<Props, State> {
  constructor (props: Props) {
    super(props)
    this.state = {
      users: [],
      revokeAll: false,
      showRevokeAll: false,
    }
  }

  componentDidMount () {
    this.props.getCustomerUsers()
  }

  componentWillReceiveProps = (nextProps: Props) => {
    if (this.state.users.length === 0 && nextProps.users.length > 0) {
      const showRevokeAll = nextProps.users.find((user) => user.permissions && user.permissions.trim() !== '')
      this.setState({users: nextProps.users, showRevokeAll: !!showRevokeAll})
    }
  }

  validate = () => {
    this.state.revokeAll ? this.props.storeFormField({'revokeAll': true})
      : this.state.users.length > 0
        ? this.props.storeFormField({'users': this.state.users})
        : this.props.setFormData(null)
  }

  updatePermissions = (data: Array<CustomerUser>) => {
    this.setState({
      users: data,
    }, this.validate)
  }

  onRevokeAllChange = (event: any) => {
    const isRevokeAllChecked = event.target.checked
    this.setState({revokeAll: isRevokeAllChecked}, this.validate)
  }

  render = () => {
    return (
      <div className='row'>
        <div className="col-md-12">
          {(this.props.fetchLoader || this.props.updateLoader) ? <div id='loader'></div> : null}
          <Users userList={this.state.users} changeUserPermissions={this.updatePermissions}
            isFetched={!this.props.fetchLoader} onRevokeAll={this.onRevokeAllChange}
            revokeAll={this.state.revokeAll} showRevokeAll={this.state.showRevokeAll}/>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  l: appSelectors.getL(state),
  users: state.app.customer.users,
  fetchLoader: state.app.customer.usersLoader,
  updateLoader: state.app.customer.updateLoader,
})

export default connect(
  mapStateToProps,
  mergeAll([appActions, formActions])
)(RawSharePortfolioForm)



// WEBPACK FOOTER //
// ./src/views/forms/share-portfolio/index.js